import { BASE_PATHS } from '@belong/common';
import type { PropertySummary } from 'api/models';

export function getSaveAndExitPath({
  properties,
}: Record<'properties', PropertySummary[]>) {
  if (properties?.length > 1) {
    return BASE_PATHS.HOMEOWNER_SETUP_FLOW;
  }

  if (properties?.length === 1) {
    // Both assertions are guarded by the length check above and by the read
    // already being unconditional.
    return `${BASE_PATHS.HOMEOWNER_SETUP_FLOW}/${properties[0]!.basicInfo!.propertyId}`;
  }

  return BASE_PATHS.ACCOUNTS;
}
